import React, { PureComponent } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import Color from './color';
import Customer from './customer';
import Installment from './installment';
import NotFound from './not-found';
import Office from './office';
import Profile from './profile';
import Purchase from './purchase';
import Report from './report';
import Role from './role';
import Sale from './sale';
import Stock from './stock';
import User from './user';
import Vehicle from './vehicle';

class Content extends PureComponent {
  render() {
    return (
      <div className="content-wrapper pt-3">
        <div className="content">
          <div className="container-fluid">
            <Switch>
              <Route
                component={Color}
                path={`${this.props.match?.path}/color`}
              />
              <Route
                component={Customer}
                path={`${this.props.match?.path}/customer`}
              />
              <Route
                component={Installment}
                path={`${this.props.match?.path}/installment`}
              />
              <Route
                component={Office}
                path={`${this.props.match?.path}/office`}
              />
              <Route
                component={Profile}
                exact
                path={`${this.props.match?.path}/profile`}
              />
              <Route
                component={Purchase}
                path={`${this.props.match?.path}/purchase`}
              />
              <Route
                component={Report}
                path={`${this.props.match?.path}/report`}
              />
              <Route component={Role} path={`${this.props.match?.path}/role`} />
              <Route component={Sale} path={`${this.props.match?.path}/sale`} />
              <Route component={Stock} path={`${this.props.match?.path}/stock`} />
              <Route component={User} path={`${this.props.match?.path}/user`} />
              <Route
                component={Vehicle}
                path={`${this.props.match?.path}/vehicle`}
              />
              <Redirect
                exact
                from={this.props.match?.path}
                to={`${this.props.match?.path}/sale`}
              />
              <Route component={NotFound} />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Content);
